/*
 * @Date: 2022-11-28 15:37:25
 * @LastEditors: guantingting
 * @LastEditTime: 2025-05-27 11:37:15
 */
import AMapLoader from "@amap/amap-jsapi-loader";
export default function loadMap() {
  window._AMapSecurityConfig = {
    securityJsCode: "b4d451263c5b4540a0d73fd7ec2fac09",
  };
  return AMapLoader.load({
    key: "b4d451263c5b4540a0d73fd7ec2fac09", // 申请好的Web端开发者Key，首次调用 load 时必填
    version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    plugins: [""], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
  });
}



// WEBPACK FOOTER //
// ./src/assets/js/loadMap.js